import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0;
`;

export const Label = styled.label``;
